import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { CARD_WRAPPER_TYPES } from '../../../shared/constants';
import { ICard } from '../../../types/shared';
import { VIEW_TYPES } from '../../organisms/navigation/shared/constants';

import { useDeviceType } from '../../../utils/generic';
import { parseSectionID } from '../../../utils/string-utils';

import mq from '../../../styles/breakpoints';
import { IntroText, ProductPageH2 } from '../../../styles/generic';
import Spacings from '../../../styles/Spacings';

import ProductFeature from '../product-feature/ProductFeature';

export interface ProductFeaturesWrapperProps {
  title?: string;
  subtitle?: string;
  features: ICard[];
  anchorName?: string;
}

const ProductFeaturesWrapper = ({
  title,
  subtitle,
  features,
  anchorName,
}: ProductFeaturesWrapperProps) => {
  const device = useDeviceType();
  const isDesktop = device === VIEW_TYPES.desktop;
  const [activeItem, setActiveItem] = useState('');

  useEffect(() => {
    if (isDesktop) {
      setActiveItem(features[0].id);
    } else {
      setActiveItem('');
    }
  }, [device]);

  const handleOnChange = (event: { open: boolean; id: string }) => {
    setActiveItem(event.open ? event.id : '');
    if (isDesktop) {
      setActiveItem(event.open ? event.id : event.id);
    } else {
      setActiveItem(event.open ? event.id : '');
    }
  };

  const id = parseSectionID(
    CARD_WRAPPER_TYPES.productFeaturesWrapper,
    anchorName
  );

  return (
    <Container id={id}>
      {(title || subtitle) && (
        <TextContainer>
          {title && <Title data-testid="title">{title}</Title>}
          {subtitle && (
            <StyledIntroText data-testid="subtitle">{subtitle}</StyledIntroText>
          )}
        </TextContainer>
      )}
      <ProductFeature
        onChange={handleOnChange}
        animateItem={false}
        activeFeatureId={activeItem}
        features={features}
      />
    </Container>
  );
};

export default ProductFeaturesWrapper;

const Container = styled.section`
  align-items: center;
  gap: 0;
  height: auto;
  padding: 0 ${Spacings.S};
  width: 100%;

  ${mq.from.breakpoint.L`
    padding: 0;
    max-width: 1056px;
  `}
`;

const TextContainer = styled.div`
  margin-bottom: ${Spacings.XL};

  ${mq.from.breakpoint.L`
    margin-bottom: 60px;
  `}
`;

const Title = styled(ProductPageH2)`
  margin: 0;
  text-align: center;
  width: inherit;
`;

const StyledIntroText = styled(IntroText)`
  display: block;
  margin-top: ${Spacings.XS};

  ${mq.from.breakpoint.L`
    margin-top: ${Spacings.S};
  `}
`;
